export const heroData = {
  runningTitle: [
    "Store it forever", // Types 'One'
    4000, // Waits 2s
    "Access it anywhere", // Types 'Second Text'
    4000, // Deletes 'One' and types 'Two' after 2s
  ],
  fixedTitle: "Lighthouse offers permanent, decentralized storage powered by Filecoin. <br/> Secure, scalable, and ideal for individuals, developers, and enterprises.",
  discordLink: "https://discord.com/invite/c4a4CGCdJG",
  twitterLink: "https://twitter.com/lighthouseweb3",
};

export const features = [
  {
    title: "Perpetual Storage",
    icon: "/others/storage.svg",
    desc: "Store files on IPFS and Filecoin",
  },
  {
    title: "Access Control",
    icon: "/others/control.svg",
    desc: "Encrypt data and build token gated apps",
  },
  {
    title: "Gateway",
    icon: "/others/gateway.svg",
    desc: "Dedicated IPFS gateways for fast retrievals",
  },
  {
    title: "Bandwidth",
    icon: "/others/bandwidth.svg",
    desc: "Image optimization to save bandwidth",
  },
];

export const featureSubtext =
  "Get verifiable storage records on chain of your choice and pay with your favorite token.";

export const blockchainList = [
  {
    icon: "/chain_icons/polygon.png",
    displayName: "Polygon",
  },
  {
    displayName: "Fantom",
    icon: "/chain_icons/fantom.png",
  },
  {
    displayName: "Optimism",
    icon: "/chain_icons/optimism.png",
  },
  {
    icon: "/chain_icons/binance.png",
    displayName: "Binance",
  },
  {
    displayName: "Ethereum",
    icon: "/chain_icons/ethereum.png",
  },
  {
    icon: "/chain_icons/filecoin.png",
    displayName: "Filecoin",
  },
];
export const partnerLogos = [
  "/partner_icons/filecoin.svg",
  "/partner_icons/filemarket.svg",
  "/partner_icons/lync.svg",
  "/partner_icons/mask.svg",
  "/partner_icons/nft_storage.svg",
  "/partner_icons/silence.svg",
  "/partner_icons/singularity.svg",
  "/partner_icons/Aethir.svg",
];

export const pricingTitle = "Pricing";

export const contactSection = {
  title: "Looking for Something more <br /> Custom?",
  card1:
    "Are you looking for something more? You can tell us more about your company and what you're building via the form below, and we'll get back to you soon.",
  card2:
    "Our team has expertise developing integrations and custom solutions for your non-fungible demand and use cases. Delivered with reliability and battle-tested for scale.",
  buttonText: "Talk to our team",
};

export const FAQSection = {
  title: "FREQUENTLY ASKED QUESTIONS",
  subTitle: "Here are some common questions about Files Dapp",
  faqs: [
    {
      question: "How long will data be stored on Lighthouse?",
      answer:
        `As we move closer to our mainnet launch, we aim to be transparent about the estimated duration of data storage. Initially, your data might be projected to remain stored for around 25 years. However, as the endowment pool grows over time, aligned with Lighthouse’s economic model, this duration is expected to increase.
If the model performs as designed, your files should remain stored for a long period without requiring additional payments as part of lifetime plan. In the unlikely event that the endowment pool depletes its funds, users might need to contribute again to continue storage`,
    },
    {
      question: "Is there a free version of Lighthouse Files Dapp?",
      answer:
        "We have a 14 day free trial for users to get started with Lighthouse Files. Check the plans above.",
    },
    {
      question: "What are upload or file size restrictions to Lighthouse Files",
      answer:
        "You can store upto 32GB in size per individual upload. Each upload can include a single file or a directory of files. For larger files, file can be broken down into 32GB chunks",
    },
    {
      question: "Can I upload private data to Lighthouse Files",
      answer:
        "By default, files uploaded are public. Users can upload an encrypted file through our encryption and access control features. Access control can also be used to token-gate files.",
    },
    {
      question: "How can I delete files stored on Lighthouse Files",
      answer:
        "We understand that not all use cases will require storing data permanently. Files can be deleted from our hot storage and other filecoin miners. However, this doesn’t prevent nodes in the IPFS network from retaining copies of data indefinitely. If you are looking for use cases involving editing the files, you can contact us via email or discord; we can discuss how you can achieve that using mutable references.",
    },
    {
      question: "How can I pay for Lighthouse Files",
      answer:
        "Users can pay on the chain of their choice using any token. At the start, we will support taking payments in stablecoins (USDC, USDT, DAI) and native chain tokens.",
    },
    {
      question: "How is it different from IPFS and Filecoin",
      answer:
        "IPFS is a distributed storage network famous for its content-addressing way of referencing files, making it tamper-proof. There is no way to pay an IPFS node to store your files in an IPFS token (because there is no such token :P). That’s why Filecoin is built on IPFS and allows anyone to pay using Filecoin tokens to store miners to store your files. Although Lighthouse is built on IPFS and Filecoin miner network, there is a couple of value adds that Lighthouse brings in 1. Permanent storage - in filecoin, you must recurrently pay for your files, or the miner will drop your files. 2. Ease of interaction - Lighthouse abstracts away complexities of directly using filecoin and dealing with the filecoin miner network 3. Private files - IPFS and Filecoin, by default, are public storage networks; anyone can see the data you upload. Building your encryption layer is not an easy job. Lighthouse provides the user with a layer of encryption and access control for encrypting files/data along with sharing with authorized users. 4. Image optimisation",
    },
    {
      question: "I am already using IPFS; how can I move my data to Lighthouse",
      answer:
        "Use the migration feature in Lighthouse Files Dapp, or for larger data, get in touch with our team",
    },
    {
      question: "What is the validity period for the Lifetime Plan, and what happens if I don't use all my storage within that time?",
      answer:
        "The Lifetime Plan provided by Lighthouse is valid for one year from the date of purchase. For instance, if you purchase a Lifetime Plan with 20 GB of storage, you need to use this space within one year. If you don't use all 20 GB within this timeframe, any unused storage will expire and will no longer be available after the one-year period.",
    },
  ],
};

export const socialLinks = {
  linkedin: "https://www.linkedin.com/company/lighthouse-web3",
  twitter: "https://twitter.com/lighthouseweb3",
  telegram: "https://t.me/LighthouseStorage",
  discord: "https://discord.com/invite/c4a4CGCdJG",
  instagram: "https://www.instagram.com/lighthouseweb3/?igshid=MDM4ZDc5MmU%3D",
  contactMail: "nandit@lighthouse.storage",
};

export const footerData = {
  sitemap: [
    {
      text: "Home",
    },
    {
      text: "Features",
    },
    {
      text: "Pricing",
    },
    {
      text: "FAQ",
    },
  ],
  otherLinks: [
    {
      text: "Contact us",
      path: null,
      link: "https://airtable.com/shrPFC2TgojuOAYO4",
    },
    {
      text: "Explorer",
      path: null,
      link: "https://explorer.lighthouse.storage/",
    },
    {
      text: "Report Online Abuse",
      path: null,
      link: "https://docs.google.com/forms/d/16STP-KPftGBCaF5MjQuXBVBOqShIxScFtuPhCAlQJM8/viewform?ts=64a7c2b5&edit_requested=true",
    },
    {
      text: "Service Level Agreement (SLA)",
      path: null,
      link: "https://docs.google.com/document/d/1wytqTDfbhlpkdKKlOMjCWtBaO5BSLnkFoNlJOw6wTUk/edit",
    },
    {
      text: "Talk to Expert",
      path: null,
      link: "https://calendly.com/nanditmehra/30min",
    },
  ],
};
